/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { jsmPreventionCenterEntryPoint } from '@jira/work-item__jsm-prevention-center/src/jsmPreventionCenter.entrypoint.tsx';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JsmWorkItemPreventionCenterEntrypointProps } from './JsmWorkItemPreventionCenter.entrypoint.types.tsx';

type JsmWorkItemPreventionCenterEntryPointComponent = EntryPointComponent<
	Record<string, never>,
	{
		preventionCenter: typeof jsmPreventionCenterEntryPoint;
	},
	JsmWorkItemPreventionCenterEntrypointProps,
	Record<string, never>
>;

export const jsmWorkItemPreventionCenterEntryPoint: EntryPoint<
	JsmWorkItemPreventionCenterEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<JsmWorkItemPreventionCenterEntryPointComponent>(
		/* webpackChunkName: "async-jsm-work-item-prevention-center" */ './JsmWorkItemPreventionCenter.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (params: EntryPointRouteParams) => ({
		entryPoints: {
			preventionCenter: {
				entryPoint: jsmPreventionCenterEntryPoint,
				entryPointParams: {
					activeTabKey: params.context.query?.tab,
					issueKey: params.context.match.params?.issueKey ?? '',
					cloudId: params.tenantContext.cloudId,
				},
			},
		},
	}),
});
